<template>

  <div v-if="current">

    <v-row>
      <v-col cols="12" sm="2">
        <v-alert dense text type="info">
          {{ counter_contratos }} contratos
        </v-alert>
      </v-col>
      <v-col cols="12" sm="2">
        <v-alert dense text type="warning">
          {{ counter_contratos_processados }} processados 
        </v-alert>
      </v-col>
      <v-col cols="12" sm="2">
        <v-alert dense text type="error">
          {{ counter_contratos_bloquear }} bloqueios
        </v-alert>
      </v-col>
      <v-col cols="12" sm="2">
        <v-alert dense text type="success">
          {{ counter_contratos_desbloquear }} desbloqueios
        </v-alert>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn color="error" @click="processar()" block>Processar bloqueio</v-btn>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn class="mr-2" color="primary" @click="atualizar()"><v-icon>mdi-refresh</v-icon></v-btn>
        <v-btn class="mr-2" color="primary" @click="csv()"><v-icon>mdi-file-delimited</v-icon></v-btn>
        <v-btn class="mr-2" color="primary" @click="whatsapp()"><v-icon>mdi-whatsapp</v-icon></v-btn>
      </v-col>
    </v-row>
    
    <v-simple-table>
      <thead>
        <tr>
          <th>Cliente</th>
          <th>Usuário</th>
          <th>Instalação</th>
          <th>Bloqueio</th>
          <th>Status</th>
          <th>Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.clientName }}</td>
          <td>{{ item.username }}</td>
          <td>{{ item.setup | formatDate }}</td>
          <td>{{ item.blockDay | formatDate }}</td>
          <td><v-chip :color="colorStatus(item)" text-color="white" small>{{ item | formatStatus }}</v-chip></td>
          <td>
            <v-btn color="success" @click="doUnblock(item.id)" small v-if="item.blockAction==2" title="Desbloquear"><v-icon>mdi-check</v-icon></v-btn>
            <v-btn color="error" @click="doBlock(item.id)" small v-if="item.blockAction==3" title="Bloquear"><v-icon>mdi-cancel</v-icon></v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    
    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_whatsapp" max-width="500px">
      <v-card>
        <v-card-title>Disparo de Bloqueio para WhatsApp</v-card-title>
        <v-card-text>
          <v-text-field
              label="Número da última cobrança"
              v-model="finalNumber"
              outlined
              dense
              ></v-text-field>
          <v-select
              label="Template"
              v-model="template"
              :items="templateList"
              item-text="name"
              return-object
              outlined
              dense
              ></v-select>
          <div v-if="template" v-html="template.content" class="wss"></div>
          <v-alert
            v-if="template"
            type="warning"
            dense
            outlined
            class="mt-3"
          >
          {{ alertMessage }}
        </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="sendWhatsapp()">Disparar</v-btn>
          <v-btn color="default" @click="dialog_whatsapp = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
import api from '../../api/index.js';
export default {
  data: () => ({
    current: [],
    counter_contratos: 0,
    counter_contratos_processados: 0,
    counter_contratos_bloquear: 0,
    counter_contratos_desbloquear: 0,
    counter_bloqueados: 0,
    dialog_loading: false,
    dialog_whatsapp: false,
    finalNumber: '',
    template: null,
    templateList: [
      { name: 'financeiro_cobranca_basica',
          content: `Prezado(a) {{nome}},
<br/><br/>
Identificamos em nosso sistema a existência de uma ou mais faturas em aberto em sua conta. Infelizmente, essa situação pode resultar no bloqueio do sinal dos serviços contratados.
<br/><br/>
O bloqueio está programado para ocorrer nos próximos dias. Para evitar quaisquer inconvenientes, solicitamos que entre em contato conosco através do botão abaixo o mais breve possível e regularize sua situação financeira.<br/><br/>`
        },
      { name: 'financeiro_bloqueio_fase1',
        content: `Prezado(a) {{nome}},
<br/><br/>
Sua internet foi bloqueada pois existe uma ou mais faturas vencidas em nosso sistema financeiro que se encontram em aberto.
<br/><br/>
Para normalizar o seu acesso a internet é muito simples. Basta efetuar o pagamento das faturas em aberto, enviar os comprovantes ao setor financeiro e no prazo de 2 horas o seu acesso já estará normalizado. 
<br/><br/>
Caso já tenha regularizado sua pendência financeira conosco, favor desconsiderar essa notificação.`
      },
      { name: 'financeiro_bloqueio_fase2',
        content: `Prezado(a) {{nome}},
<br/><br/>
Sua internet permanece bloqueda! Existe uma ou mais faturas vencidas em nosso sistema financeiro que se encontram em aberto. O pagamento também evita a negativação do seu cadastro.
<br/><br/>
Para normalizar o seu acesso a internet é muito simples. Basta efetuar o pagamento das faturas em aberto, enviar os comprovantes ao setor financeiro e no prazo de 2 horas o seu acesso já estará normalizado. 
<br/><br/>
Caso já tenha regularizado sua pendência financeira conosco, favor desconsiderar essa notificação.`
      },
      { name: 'financeiro_bloqueio_fase3',
        content: `Prezado(a) {{nome}},
<br/><br/>
Até o momento, não identificamos o pagamento e informamos que o processo de inadimplência está avançando.
Caso a pendência não seja regularizada, o contrato seguirá para rescisão definitiva, conforme as condições contratuais.
Evite transtornos. Regularize agora.
<br/><br/>
Caso já tenha regularizado sua pendência financeira conosco, favor desconsiderar essa notificação.`
      },
      { name: 'financeiro_bloqueio_fase4',
        content: `Prezado(a) {{nome}},
<br/><br/>
Como o pagamento ainda não foi efetuado, informamos que o processo está em fase final, podendo resultar em:<br/>
•	Rescisão definitiva do contrato<br/>
•	Cobrança de multas contratuais<br/>
•	Agendamento para coleta dos equipamentos<br/>
A regularização ainda pode ser feita de forma simples, com o pagamento do débito.<br/>
Evite transtornos. Regularize agora.
<br/><br/>
Caso já tenha regularizado sua pendência financeira conosco, favor desconsiderar essa notificação.`
      }
    ],
  }),
  created: function() {
    this.atualizar();
  },
  computed: {
    alertMessage: function(){
      if(this.template && this.template.name.includes('cobranca')){
        return 'Deseja enviar a mensagem de cobrança para todos os passíveis de bloqueio do mês?';
      }
      if(this.template && this.template.name.includes('bloqueio')){
        return 'Deseja enviar a mensagem de bloqueio para todos os bloqueados do mês?';
      }
      return '';
    }
  },
  methods: {
    atualizar: function(){
      this.listBloqueios();
      this.countContratos();
      this.countContratosProcessados();
      this.countContratosBloquear();
      this.countContratosDesbloquear();
    },
    countContratos: function(){
      var me = this;
      var token = localStorage.getItem("token");
      api.get("/internet/bloqueio/contratos/count", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.counter_contratos = response.data;
      }) 
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar contagem!");
      });
    },
    countContratosProcessados: function(){
      var me = this;
      var token = localStorage.getItem("token");
      api.get("/internet/bloqueio/processados/count", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.counter_contratos_processados = response.data;
      }) 
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar contagem!");
      });
    },
    countContratosBloquear: function(){
      var me = this;
      var token = localStorage.getItem("token");
      api.get("/internet/bloqueio/bloquear/count", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.counter_contratos_bloquear = response.data;
      }) 
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar contagem!");
      });
    },
    countContratosDesbloquear: function(){
      var me = this;
      var token = localStorage.getItem("token");
      api.get("/internet/bloqueio/desbloquear/count", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.counter_contratos_desbloquear = response.data;
      }) 
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar contagem!");
      });
    },
    listBloqueios: function() {
      var me = this;
      me.current = [];
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.get("/internet/bloqueio", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        me.current = response.data;
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar listagem!");
      });
    },
    processar: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_check = false;
      me.dialog_loading = true;
      api.post("/internet/bloqueio/rapido", null, {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        if(response.data=='started'){
            alert("Processamento iniciado com sucesso!");
        } else if(response.data=='running'){
            alert("Já existe um processamento em andamento!");
        } else {
            alert("Falha ao iniciar o processamento do bloqueio!");
        }
        me.atualizar();
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao solicitar processamento do bloqueio!");
      });
    },
    doBlock(id){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_check = false;
      me.dialog_loading = true;
      api.put("/internet/doblock/"+id, {status:3}, {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        console.log(response);
        alert("Bloqueado com sucesso!");
        me.listBloqueios();
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao solicitar bloqueio!");
      });
    },
    doUnblock(id){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_check = false;
      me.dialog_loading = true;
      api.put("/internet/dounblock/"+id, {status:0}, {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        console.log(response);
        alert("Desbloqueado com sucesso!");
        me.listBloqueios();
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao solicitar desbloqueio!");
      });
    },
    colorStatus: function(item){
      var color = "success";
      if (item.status==1){
        color = "warning";
      }else if(item.status==2){
        color = "secondary";
      }else if(item.status==3){
        color = "error";
      }else if(item.status==4){
        color = "default";
      }
      return color;
    },
    csv: function(){
      var content = "";
      for(var i=0;i<this.current.length;i++){
        let internet = this.current[i];
        content += ""+internet.clientCellphone+";"+internet.clientName+"\n";
      }
      var blob = new Blob([content], { type: "text/csv" });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = url;
      let df = new Date().toISOString();
      a.download = "bloqueios-"+df+".csv";
      document.body.appendChild(a);
      a.click();
    },
    whatsapp: function(){
      var me = this;
      me.dialog_whatsapp = true;
    },
    sendWhatsapp: function(){
      var me = this;
      var token = localStorage.getItem("token");
      if(me.template==null) { 
        alert('Selecione o template.'); 
        return;
      }
      me.dialog_whatsapp = false;
      me.dialog_loading = true;
      api.post("/internet/bloqueio/whatsapp/send", { finalNumber: me.finalNumber, template: me.template.name }, {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        console.log(response.data);
      }) 
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao disparar mensagens!");
      });
    }
  },
  filters: {
    formatStatus: function(item){
      var text = "Habilitado";
      if (item.status==1){
        text = "Bloqueio administrador";
      }else if(item.status==2){
        text = "Bloqueio cliente";
      }else if(item.status==3){
        text = "Bloqueio pagamento";
      }else if(item.status==4){
        text = "Cancelado";
      }
      return text;
    }
  }
}

</script>

<style lang="css">
.wss {
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 14px;
  background-color: rgb(196, 248, 212);
  margin-bottom: 32px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  color: black;
}
</style>
